import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import paymentsPoweredByStripeRight from '../../assets/Powered_by_Stripe_right.svg';

import css from './SecurePaymentsBadge.module.css';

const ShieldIcon = ({ className = null }) => (
  <svg
    className={classNames(css.shieldIcon, className)}
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M12 2.75 19 5.4v5.1c0 4.55-2.86 8.64-7 10.18-4.14-1.54-7-5.63-7-10.18V5.4l7-2.65Z"
      fill="currentColor"
    />
    <path
      d="m9.25 12.15 1.45 1.45 4.1-4.18"
      fill="none"
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.1"
    />
  </svg>
);

ShieldIcon.propTypes = {
  className: PropTypes.string,
};

const SecurePaymentsBadge = ({ className = null, iconOnly = false }) => {
  if (iconOnly) {
    return <ShieldIcon className={className} />;
  }

  return (
    <a
      className={classNames(css.root, className)}
      href="https://stripe.com/"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Secure payments powered by Stripe"
    >
      <img
        className={css.poweredByStripeMark}
        src={paymentsPoweredByStripeRight}
        alt=""
        aria-hidden="true"
        draggable="false"
      />
    </a>
  );
};

SecurePaymentsBadge.propTypes = {
  className: PropTypes.string,
  iconOnly: PropTypes.bool,
};

export default SecurePaymentsBadge;
